const Pagination = Vue.component('pagination', {
  props: {
    currentPage: Number,
    totalPages: Number
  },
  template: '#pst-search-pagination',
  methods: {
    navigate(back = false) {
      // scroll({
      // 	top: 0,
      // 	behavior: 'smooth',
      // });
      back ? this.$emit('previous-page') : this.$emit('next-page')
    }
  }
})

const ResultCard = Vue.component('result-card', {
  props: {
    type: String,
    data: Object | Array
  },
  data() {
    return {
      classes: `result result--${this.type}`
    }
  },
  computed: {
    hasLink: function () {
      return this.type === 'post' && this.data.post_type === 'product'
    },
    hasDownload: function () {
      return (
        this.data.post_type !== 'video' &&
        this.data.post_type !== 'product' &&
        this.data.acf &&
        this.data.acf.file
      )
    },
    hasVideo: function () {
      return this.data.post_type === 'video' && this.data.hasVideo
    },
    hasShare: function () {
      return this.data.post_type !== 'product'
    }
  },
  template: '#pst-search-result-card'
})

const FilterSidebar = Vue.component('filter-sidebar', {
  props: {
    initialFilters: Array | Object,
    totalResults: Number
  },
  data() {
    return {
      movePlaceholder: false,
      filters: this.initialFilters,
      stateFilterIsVisible: false,
      provinceFilterIsVisible: false,
      stateFilterName: ''
    }
  },
  watch: {
    filters: {
      deep: true,
      handler: function (newFilters, oldFilters) {
        newFilters = Object.values(newFilters)

        let countryFilters = newFilters.filter(f => f.slug === 'country')

        if (countryFilters.length === 0) {
          this.stateFilterIsVisible = false
          this.provinceFilterIsVisible = false
          return
        }

        const usaTermIds = [132, 1316, 1317, 1318]
        let usaChecked = countryFilters[0].terms.filter(
          t => t.checked && usaTermIds.includes(t.term_id)
        )
        let canadaChecked = countryFilters[0].terms.filter(
          t => t.checked && t.slug === 'canada'
        )

        this.stateFilterIsVisible = usaChecked.length > 0
        this.provinceFilterIsVisible = canadaChecked.length > 0
      }
    }
  },
  methods: {
    // translatedSlugsDataAttributes(translatedSlugs) {
    //   const dataAttributes = {};
    //   for (const [key, value] of Object.entries(translatedSlugs)) {
    //     // Prefix each key with 'data-' and replace it in the object
    //     dataAttributes[`data-${key}`] = value;
    //   }
    //   return dataAttributes;
    // },
    togglePlaceholder(e) {
      const eventValue = e.target.value
      this.movePlaceholder = !this.movePlaceholder

      if (eventValue.length) {
        this.movePlaceholder = true
      }
    },

    resetFilters() {
      Object.keys(this.filters).forEach(f => {
        if (this.filters[f].checked === undefined) return
        this.filters[f].checked = false
      })
      this.query = ''
      this.filters = this.initialFilters
      this.stateFilterIsVisible = false
      this.provinceFilterIsVisible = false
      this.stateFilterName = ''
      this.$emit('filters-reset', this.filters)
      let searchField = jQuery('#searchFromTop')
      searchField.val('')
      searchField.parent().removeClass('placeholderMoved')
    },
    filterIsVisible(filter) {
      if (['state', 'province'].indexOf(filter.slug) < 0) return true

      if (filter.slug === 'state') return this.stateFilterIsVisible
      if (filter.slug === 'province') return this.provinceFilterIsVisible
    },
    termIsVisible(searchTerm, term) {
      if (typeof searchTerm === 'undefined') return true

      return term.name.toLowerCase().includes(searchTerm.toLowerCase())
    },
    subfiltersOpened(event) {
      const arrow = jQuery(event.currentTarget)
      arrow.toggleClass('pst-filters__arrow--open')
      arrow.parent().next().slideToggle(200)
    }
  },
  template: '#pst-filter-sidebar'
})

const PostCategoryOptions = Vue.component('post-category-options', {
  props: {
    options: Array | Object
  },
  data() {
    return {
      categories: this.options,
      activeCat: '',
      categoriesActive: []
    }
  },
  methods: {
    updateCategory(newCategory) {
      this.activeCat = newCategory
      this.$emit('category-updated', newCategory)
    },
    resetCategories() {
      this.activeCat = ''
    },
    isActive(c) {
      return this.activeCat === c
    }
  },
  template: '#pst-post-search-category-options'
})

export const PXPostSearch = (function () {
  'use strict'

  let app

  function init() {
    let root = document.getElementById('poly-post-search');

    if (!root) return

    // console.log('test');

    let initialCategories = [];
    let categories = null;

    if(root.dataset.type == 'news') {
      if(root.dataset.translatedCategories) {
        categories = root.dataset.translatedCategories;
        if (categories) {
            let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?categories=' + categories;
            window.history.replaceState({path: newUrl}, '', newUrl);
        }
      } else {
        let urlParams = new URLSearchParams(window.location.search);
        categories = urlParams.get('categories');
      }

      if(categories != null) {
        initialCategories = categories.split(',');
      } 
    }

    let hrefLangLinks = document.querySelectorAll('link[rel="alternate"][hreflang]');
    let wpmlLinks = document.querySelectorAll('.wpml-ls-link');
    let combinedLinks = Array.from(hrefLangLinks).concat(Array.from(wpmlLinks));
    
    if(combinedLinks.length > 0) {
      combinedLinks.forEach(el => {
        let categoriesQueryString = '';
        if(categories) {
            categoriesQueryString = '?categories=' + categories;
        }
        let urlWithoutQuery = el.href.split('?')[0];
        let newUrl = urlWithoutQuery + categoriesQueryString;
        el.href = newUrl;
      });
    }

    app = new Vue({
      el: root,
      components: {
        FilterSidebar,
        PostCategoryOptions,
        ResultCard,
        Pagination
      },
      data() {
        return {
          query: '',
          totalResults: 0,
          totalPages: 0,
          currentPage: 1,
          moveTopPlaceholder: false,
          signupName: '',
          signupEmail: '',
          resultType: root.dataset.type,
          industryType: root.dataset.industryType,
          newPosts: root.dataset.newPosts,
          trendingPosts: root.dataset.trendingPosts,
          currentCategories: initialCategories,
          results: [],
          activeFilters: [],
          current_site_language: PXConstants.current_site_language,
          isLoading: false
        }
      },
      methods: {
        dynamicResultContainerClass(resultType) {
          return 'results__container results__container--' + resultType
        },

        handleSearchBlur(e) {
          this.toggleTopPlaceholder(e)
          this.fetchResults(e)
        },

        showModal(modalID) {
          MicroModal.show(modalID)
        },

        toggleTopPlaceholder(e) {
          const eventValue = e.target.value
          this.moveTopPlaceholder = !this.moveTopPlaceholder

          if (eventValue.length) {
            this.moveTopPlaceholder = true
          }
        },

        navigate(back = false) {
          if (
            (!back && this.currentPage === this.totalPages) ||
            (back && this.currentPage === 1)
          )
            return

          back ? this.currentPage-- : this.currentPage++

          this.fetchResults()
        },
 
        filtersUpdated(filters) {
          this.currentPage = 1;
          if(this.resultType == 'news') {
            let activeInputs = document.querySelectorAll('.pst-filters input:checked');
            let activeFilters = [];

            activeInputs.forEach(input => {
              activeFilters.push(input.value);
            });

            this.currentCategories = activeFilters;
            this.fetchResults()
            this.updateQueryString();
          } else {

            let parsedFilters = []
            let iterable = !Array.isArray(filters)
              ? Object.keys(filters)
              : filters

            iterable.forEach(item => {
              let val = !Array.isArray(filters) ? filters[item] : item
              let activeTerms = val.terms.filter(term => term.checked)

              if (activeTerms.length > 0) {
                parsedFilters.push({
                  slug: val.slug,
                  values: activeTerms.map(term => term.slug)
                })
              } else {
                if (
                  val.checked &&
                  this.currentCategories.indexOf(val.slug) === -1
                ) {
                  this.currentCategories.push(val.slug)
                } else if (
                  !val.checked &&
                  this.currentCategories.indexOf(val.slug) > -1
                ) {
                  this.currentCategories.splice(
                    this.currentCategories.indexOf(val.slug),
                    1
                  )
                }

                if (val.children) {
                  for (const child of val.children) {
                    if (
                      child.checked &&
                      this.currentCategories.indexOf(child.slug) === -1
                    ) {
                      this.currentCategories.push(child.slug)
                    } else if (
                      !child.checked &&
                      this.currentCategories.indexOf(child.slug) > -1
                    ) {
                      this.currentCategories.splice(
                        this.currentCategories.indexOf(child.slug),
                        1
                      )
                    }
                  }
                }
              }
            })

            this.activeFilters = parsedFilters;
            this.fetchResults();
          } // endif
        },

        updateQueryString(){
            let categories = this.currentCategories.join(',');
            if(this.currentCategories.length > 0) {
              let queryString = '?categories=' + categories;
              window.history.replaceState({}, document.title, queryString);
            } else {
              let clean_url = window.location.protocol + "//" + window.location.host + window.location.pathname;
              window.history.replaceState({}, document.title, clean_url);
            }

            let hrefLangLinks = document.querySelectorAll('link[rel="alternate"][hreflang]');
            let wpmlLinks = document.querySelectorAll('.wpml-ls-link');
            let combinedLinks = Array.from(hrefLangLinks).concat(Array.from(wpmlLinks));

            if(combinedLinks.length > 0) {
              combinedLinks.forEach(el => {
                let categoriesQueryString = '';
                if(categories) {
                    categoriesQueryString = '?categories=' + categories;
                }
                let urlWithoutQuery = el.href.split('?')[0];
                let newUrl = urlWithoutQuery + categoriesQueryString;
                el.href = newUrl;
              });
            }
        },

        categoryUpdated(category) {
          // tobedone - check if all's good with emptying categories before pushing
          this.currentCategories = []
          this.currentCategories.push(category)
          this.fetchResults()
        },

        filtersReset(filters) {
          this.currentCategories = []
          this.activeFilters = []
          this.query = ''
          history.pushState({}, document.title, window.location.pathname)
          this.fetchResults()
        },

        signUpForm() {
          // axios
          // 	.post('some-endpoint', {
          // 		a: 'b',
          // 	})
          // 	.then((response) => console.log(response))
          // 	.catch((error) => console.log(error));
        },

        fetchResults(ev) {
          if (ev) ev.preventDefault()

          let searchEndpoint = ''
          this.isLoading = true
          let categories = this.currentCategories;

          switch (this.resultType) {
            case 'representative':
              searchEndpoint = '/wp-json/wp/v2/repsearch'
              break

            case 'news':
              searchEndpoint = '/wp-json/wp/v2/newssearch'
              break

            default:
              searchEndpoint = '/wp-json/wp/v2/repsearch'
              break
          }

          if(this.resultType == 'news') {
            let activeInputs = document.querySelectorAll('.pst-filters input:checked');  
            activeInputs.forEach(input => {
              categories = categories.filter(category => category !== input.dataset.parent);
            });  
          }

          axios
            .post(searchEndpoint, {
              s: this.query,
              tag: jQuery('.current_tag').length
                ? jQuery('.current_tag').text()
                : null,
              page: this.currentPage,
              filters: this.activeFilters,
              currentSiteLanguage: this.current_site_language,
              industryType: this.industryType,
              newPosts: this.newPosts,
              trendingPosts: this.trendingPosts,
              category: categories
                .filter((v, i, a) => a.indexOf(v) === i)
                .join(',')
            })
            .then(response => {
              // console.log('HIT SUCCESS')
              // console.log(response)
              // console.log('Posts: ', response.data);

              this.totalResults = +response.headers['x-wp-total']
              this.totalPages = +response.headers['x-wp-totalpages']
              this.results = response.data
            })
            .catch(error => {
              // console.log('HIT ERROR')
              // console.log(error)
            })
            .finally(() => {
              // console.log('HIT FINALLY')
              this.isLoading = false
            })
        }
      },
      mounted() {
        if(this.resultType == 'news' && this.currentCategories.length > 0) {
          this.currentCategories.forEach(category => {
            let categoryCheckbox = document.getElementById('pst-filter-' + category);
            if(categoryCheckbox) {
              categoryCheckbox.checked = true;
            }
          });
        }

        this.fetchResults();
      }

    })
  }

  return {
    init: init
  }
})()
